import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export const TableDesktopFooterMenu = ({
  openModal,
  tableContext,
  buttonLabel
}: {
  openModal?: () => void;
  tableContext?: any;
  buttonLabel?: string;
}) => {
  // Use loading from tableContext if available, otherwise default to false
  const loading = tableContext && typeof tableContext === 'function'
    ? tableContext()?.loading ?? false
    : false;

  return (
    <Box className="controls-bar desktop bottom">
      <Button
        color="success"
        onClick={openModal}
        startIcon={<AddIcon />}
        variant="contained"
        disabled={loading}
        sx={{
          borderRadius: 2,
        }}
      >
        {buttonLabel ?? 'Add New'}
      </Button>
    </Box>
  );
};

export default TableDesktopFooterMenu;